module.exports = __webpack_public_path__ + "img/rcgysq_sqdx.fb38fedc.png";